import { useEffect, useState } from "react";

import { generateTotp, isValidSecret, normalizeSecret } from "@ext/crypto/totp";

import { CopyButton } from "./CopyButton";

interface Props {
  secret: string;
  onCopy?: () => void;
}

export function TotpDisplay({ secret, onCopy }: Props) {
  const [state, setState] = useState<{ code: string; secondsRemaining: number; period: number } | null>(
    null,
  );
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isValidSecret(secret)) {
      setError("Niepoprawny klucz TOTP");
      setState(null);
      return;
    }
    setError(null);

    let cancelled = false;
    async function tick() {
      try {
        const r = await generateTotp(normalizeSecret(secret));
        if (!cancelled) setState(r);
      } catch (e) {
        if (!cancelled) setError((e as Error).message);
      }
    }
    tick();
    const interval = setInterval(tick, 1000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [secret]);

  if (error) return <div className="error">{error}</div>;
  if (!state) return <div className="muted">Liczę…</div>;

  const formatted =
    state.code.length === 6 ? `${state.code.slice(0, 3)} ${state.code.slice(3)}` : state.code;
  const pct = (state.secondsRemaining / state.period) * 100;
  const urgent = state.secondsRemaining <= 5;
  const barColor = urgent ? "var(--danger)" : "var(--accent)";

  return (
    <div className="totp-card">
      <div className="totp-label">Kod 2FA</div>
      <div className="totp-code" style={{ color: barColor }}>
        {formatted}
      </div>
      <div className="totp-meta">
        <div className="totp-progress">
          <div className="totp-progress-bar" style={{ width: `${pct}%`, background: barColor }} />
        </div>
        <span className="muted" style={{ minWidth: 28, textAlign: "right" }}>
          {state.secondsRemaining}s
        </span>
        <CopyButton text={state.code} onCopy={onCopy} />
      </div>
    </div>
  );
}
